export const validateCustomerForm = ({
  firstName,
  lastName,
  email,
  phone,
  businessName,
  customerType,
}: any) => {
  const errors = {
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    businessName: "",
  };

  if (customerType === "individual") {
    if (!firstName) {
      errors.firstName = "First Name is required";
    }
    if (!lastName) {
      errors.lastName = "Last Name is required";
    }
  } else {
    if (!businessName) {
      errors.businessName = "Business Name is required";
    }
  }

  // Check if any error messages are present
  const hasErrors = Object.values(errors).some((error) => error !== "");

  return { hasErrors, errors };
};
